module.exports = __webpack_public_path__ + "static/transactional-email-example-b25a47da6d648b0f58caf544ecdc77db.png";